// Maps the `icon` key on each service entry to its bundled asset.
// Static imports so webpack can fingerprint and cache-bust them.
import web_development from './images/gif/web_development.gif';
import mobile_app from './images/gif/mobile_app.gif';
import ux_design from './images/gif/ux_design.gif';
import digital_marketing from './images/gif/digital_marketing.gif';
import cloud_solutions from './images/gif/cloud_solutions.gif';
import software_development from './images/gif/software_development.gif';
import consulting from './images/gif/consulting.gif';
import cybersecurity from './images/gif/cybersecurity.gif';

const icons = {
  web_development,
  mobile_app,
  ux_design,
  digital_marketing,
  cloud_solutions,
  software_development,
  consulting,
  cybersecurity,
};

export default icons;
